import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CaregiverSignUpScreen from './screens/CaregiverSignUpScreen';
import SignUpScreen from './screens/SignUpScreen';
import PreRegistrationCompleteScreen from './screens/PreRegistrationCompleteScreen';
import TermsOfUse from './screens/TermsOfUse';
import PrivacyPolicy from './screens/PrivacyPolicy';
import VerifyEmail from './screens/VerifyEmail'; 
import LoginScreen from './screens/LoginScreen';
import Footer from './screens/Footer';
import PrivateRoute from './screens/PrivateRoute'; 

// Importa os novos componentes internos
import MinhaConta from './screens/MinhaConta';
import BuscarVagas from './screens/BuscarVagas';
import Support from './screens/Support';
import Home from './screens/Home';
import AssinaturaSucesso from './screens/AssinaturaSucesso';

import './App.css';

function App() {

  useEffect(() => {
    // Adiciona a tag do Google Analytics/Google Ads
    const script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-LZ15KQH4X5";
    script.async = true;
    document.head.appendChild(script);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-LZ15KQH4X5');
    `;
    document.head.appendChild(script2);
  }, []);

  return (
    <Router>
      <div className="App">
        <div className="content">
          <Routes>
            {/* Rotas públicas */}
            <Route path="/" element={<LoginScreen />} />
            <Route path="/login" element={<LoginScreen />} /> {/* Adiciona explicitamente a rota /login */}
            <Route path="/signup" element={<SignUpScreen />} />
            <Route path="/caregiver-signup" element={<CaregiverSignUpScreen />} />
            <Route path="/pre-registration-complete" element={<PreRegistrationCompleteScreen />} />
            <Route path="/termos-de-uso" element={<TermsOfUse />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/assinatura-sucesso" element={<AssinaturaSucesso />} />

            {/* Rotas privadas - agrupadas sob o PrivateRoute */}
            <Route element={<PrivateRoute />}>
              <Route path="/home" element={<Home />} />
              <Route path="/minha-conta" element={<MinhaConta />} />
              <Route path="/buscar-vagas" element={<BuscarVagas />} />
              <Route path="/support" element={<Support />} />
            </Route>
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
